import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reportLogOut } from 'a/actions/searchlightActions';
import { closeLogoutModal } from 'a/hub/actions/modalSystemActions';
import { getOpenModalConfig } from 'a/hub/selectors/modalSystemSelectors';
import GenericLogOutModal from 'a/hub/components/MapLogoutModal';
import AnimatedModal from './AnimatedModal';

const LogoutModal = () => {
  const dispatch = useDispatch();

  const { origin = 'origin unknown' } = useSelector(getOpenModalConfig) || {};

  const onCancel = () => {
    dispatch(closeLogoutModal());
  };

  const onLogout = () => {
    dispatch(reportLogOut(origin));
  };

  return (
    <AnimatedModal>
      <GenericLogOutModal
        onCancel={onCancel}
        onLogout={onLogout}
      />
    </AnimatedModal>
  );
};

export default LogoutModal;
